// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"850":"37241f14","1981":"79458df9","2572":"c65c697d"}[chunkId] + ".chunk.css";
};